import Home from "./pages/Home";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { LoadingScreen } from "./components/LoadingScreen";

const App = () => {
  return (
    <>
      <Home />
      <ToastContainer />
      <LoadingScreen />
    </>
  );
};

export default App;
